import thunkMiddleware from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';

import reducer from 'app/modules';
import redactionMiddleware from 'infrastructure/middleware/redactionMiddleware';
import errorMiddleware from 'infrastructure/middleware/errorMiddleware';
import gatewayMiddleware from 'infrastructure/middleware/gatewayMiddleware';
import analyticsMiddleware from 'infrastructure/middleware/analyticsMiddleware';
import cookiesMiddleware, { updateInitialStateFromCookies } from 'infrastructure/middleware/cookiesMiddleware';

export default function configureStore(context, initialState) {
  const middlewares = [];

  // read stored data in cookies and merge it with the initial state
  initialState = updateInitialStateFromCookies(context, initialState);

  middlewares.push(thunkMiddleware);
  /* important to keep the redaction middleware up top so that things
   that need to be redacted do not make it into our store or to our messaging provider */
  middlewares.push(redactionMiddleware());
  middlewares.push(gatewayMiddleware(context));
  middlewares.push(analyticsMiddleware(context));
  middlewares.push(errorMiddleware(context));
  middlewares.push(cookiesMiddleware(context));

  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger);
  }

  return compose(applyMiddleware(...middlewares))(createStore)(reducer, initialState);
}
